import { ChevronLeft } from 'lucide-react';
import { mkIcon } from './utils';
export const SvgCheveronLeft = mkIcon(ChevronLeft);